<template>

    <ui-panel class="parcel-detail">

        <h2>Perceel
            <template>
                {{ parcel.parcelLocation.name }} {{ parcel.parcelLocation.number }}
            </template>
            <template v-if="parcel.alias">
                - {{ parcel.alias }}
            </template>
        </h2>

        <span class="efficiency">Rendement: {{ parcel.efficiency * 100 | number }}%</span>
        <span class="efficiency" v-if="parcelSowingDensity != null">Zaaidichtheid: {{ parcelSowingDensity | number }} mTon/ha</span>

        <pm-section-detail
            v-for="section in sections"
            :key="section.id"
            :section="section"
            :parcel="parcel"
            :editable="editable"
            :deletable="deletable"
            :type="type"
            :start-date="startDate"
            :end-date="endDate"
            :open="openSectionTables.indexOf(section.id) >= 0"
            @toggle="toggleSectionTable(section.id)" />

    </ui-panel>

</template>

<script>

import Vue from 'vue';
import { without } from 'es-toolkit';
import Component from 'vue-class-component';

import SectionDetail from './SectionDetail.vue';

@Component({

    name: 'ParcelDetail',
    props: {
        parcel: Object,
        sections: Array,
        collapsible: Boolean,
        editable: Boolean,
        deletable: Boolean,
        type: String,
        startDate: String,
        endDate: String
    },
    components: {
        'pm-section-detail': SectionDetail
    }
})
export default class ParcelDetail extends Vue {

    loading = 0;
    openSectionTables = [];

    toggleSectionTable(sectionId) {

        if(this.openSectionTables.indexOf(sectionId) >= 0) {

            this.openSectionTables = without(this.openSectionTables, sectionId);
        }
        else {

            this.openSectionTables.push(sectionId);
        }
    }

    get parcelSowingDensity() {

        if(!this.sections?.length) {
            return null;
        }

        let total = 0;
        let hasValue = false;

        for(const section of this.sections) {

            const density = section.activeCohort?.sowingDensity;

            if(!density) {
                continue;
            }

            const value = density.bruto ?? density.netto;

            if(value == null) {
                continue;
            }

            total += value;
            hasValue = true;
        }

        return hasValue ? total : null;
    }
}

</script>